import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ページ遷移（URL パスの変化）を検知し、画面本体（window）の縦スクロールを
 * 最上部へ戻すための裏方コンポーネント。UI は描画しない。
 *
 * <Router> 直下に 1 つ配置するだけで全ページ横断で機能する。
 * 動かすのは window のスクロールのみで、一覧テーブルの内部スクロール
 * （TableContainer の scrollTop による一覧⇔詳細の位置保持）には干渉しない。
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
